<template>
  <el-card :body-style="bodyStyle" class="vab-card" :shadow="shadow">
    <template v-if="$slots.header || header" #header>
      <slot name="header">{{ header }}</slot>
      <el-button
        style="float: right; position: relative; bottom: 5px"
        type="text"
        size="medium"
        icon="el-icon-arrow-down"
      ></el-button>
    </template>
    <el-skeleton
      v-if="localSkeleton"
      animated
      :loading="skeletonShow"
      :rows="skeletonRows"
    >
      <template #default>
        <slot class="vab-card-transition" />
      </template>
    </el-skeleton>
    <slot v-else class="vab-card-transition" />
  </el-card>
</template>

<script>
  import request from '@/utils/request'
  import _ from 'lodash'
  export default {
    name: 'VabCard',
    props: {
      header: {
        type: String,
        default: '',
      },
      bodyStyle: {
        type: Object,
        default: () => {
          return {}
        },
      },
      apiUrl: {
        type: String,
        default: '',
      },
      prop: {
        type: String,
        default: '',
      },
      queryParams: {
        type: Object,
        default: null,
      },
      shadow: {
        type: String,
        default: 'hover',
      },
      skeleton: {
        type: Boolean,
        default: true,
      },

      skeletonRows: {
        type: Number,
        default: 7,
      },
    },
    data() {
      return {
        params: null,
        localSkeleton: this.skeleton,
        skeletonShow: true,
      }
    },
    computed: {
      form() {
        let parent = this.$parent
        let parentName = parent.$options.componentName
        while (parentName !== 'ElForm') {
          parent = parent.$parent
          parentName = parent.$options.componentName
        }
        return parent
      },
    },
    mounted() {
      this.params = Object.assign({}, this.$route.query, this.queryParams)
      this.fetchData()
    },
    methods: {
      async fetchData() {
        let vm = this
        if (this.apiUrl && this.params && this.params.id) {
          const { data } = await request({
            url: this.apiUrl,
            method: 'get',
            params: { ...this.params },
          })
          if (data) {
            if (this.prop) {
              this.$set(this.form.model, this.prop, data)
            } else {
              _.forOwn(data, (value, key) => {
                this.$set(this.form.model, key, value)
              })
            }
          }
        }
        vm.localSkeleton = false
      },
    },
  }
</script>

<style lang="scss" scoped>
  .vab-card {
    ::v-deep .el-popover__reference-wrapper .el-button--mini {
      padding: 6px 3px !important;
    }
    &-transition {
      transition: $base-transition;
    }
  }
</style>
